<script setup lang="ts">
    import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogTrigger,
    } from '@/components/ui/alert-dialog';
    import { useForm } from '@inertiajs/vue3';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { Procedure } from '@/types';
    import { Button } from '@/components/ui/button';

    const { t } = useI18n();

    const props = defineProps<{
        procedure: Procedure;
    }>();

    const emit = defineEmits(['deleted']);

    const form = useForm({
        procedure_id: props.procedure.procedure_id,
    });

    const deleteProcedure = () => {
        form.post(route('v2.dashboard.procedures.delete'), {
            preserveScroll: true,
            onSuccess: () => {
                toast.success(t('dashboards.procedures_delete_success'));
                emit('deleted');
            },
            onError: (error) => {
                toast.error(t('forms.general.error'));
            },
        });
    };
</script>

<template>
    <AlertDialog>
        <AlertDialogTrigger as-child>
            <Button
                variant="link_destructive"
                size="none"
                class="mr-auto"
            >
                <span>{{ $t('dashboards.procedures_delete') }}</span>
            </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle>{{ t('dashboards.procedures_delete') }}</AlertDialogTitle>
                <AlertDialogDescription>{{
                    t('dashboards.procedures_delete_confirm')
                }}</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <AlertDialogCancel>{{ t('users.js.no') }}</AlertDialogCancel>
                <AlertDialogAction
                    @click="deleteProcedure"
                    variant="destructive"
                >
                    {{ t('users.js.yes') }}
                </AlertDialogAction>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
</template>
